module.exports = __webpack_public_path__ + "static/media/badge-twitter.7b55f360.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-twitter.png
// module id = 308
// module chunks = 0